import { render, staticRenderFns } from "./TSeriesProductList.vue?vue&type=template&id=0b7539d4&scoped=true"
import script from "./TSeriesProductList.vue?vue&type=script&lang=js"
export * from "./TSeriesProductList.vue?vue&type=script&lang=js"
import style0 from "./TSeriesProductList.vue?vue&type=style&index=0&id=0b7539d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7539d4",
  null
  
)

export default component.exports